import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { TyreStateValueListModel } from '../../models/tyre/tyreStateValue';
import * as TyreStateModels from '../../models/tyre/tyreState';
import * as TyreStateSearchModels from '../../models/tyre/tyreStateSearch';
import { TyrePositionDictionaryListModel } from '../../models/tyre/tyrePosition';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from '../../models/commonModels';
import * as DepositeModels from '../../models/deposite/deposite';


@Injectable({
  providedIn: 'root'
})
export class TyreStateService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getTyreStateValuesDictionary() {
    return this.httpClient.get<TyreStateValueListModel>(`${this.environmentService.getApiURL()}/tyre-state/tyre-state-values`);
  }

  public getTyrePositionDictionary() {
    return this.httpClient.get<TyrePositionDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre-state/tyre-positions`);
  }

  public getDepositeTyreState(Search: TyreStateSearchModels.TyreStateSearchRequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<TyreStateModels.TyreStateListModel>(`${this.environmentService.getApiURL()}/tyre-state/deposite-tyre-states`, Search, options);
  }

  public getLastReturnedTyreState(Search: TyreStateSearchModels.TyreStateSearchRequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreStateModels.TyreStatePreviewModel[]>>(`${this.environmentService.getApiURL()}/tyre-state/last-return-tyre-states`, Search, options);
  }

  public getLastUtylizedTyreState(Search: TyreStateSearchModels.TyreStateSearchRequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreStateModels.TyreStatePreviewModel[]>>(`${this.environmentService.getApiURL()}/tyre-state/last-utylized-tyre-states`, Search, options);
  }

  public setDepositeTyreState(RequestNewOrder: Models.RequestNewOrder<TyreStateModels.TyreStateModel[]>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreStateModels.TyreStateListModel>(`${this.environmentService.getApiURL()}/tyre-state/set-deposite-tyre-states`, RequestNewOrder, options);
  }

  public setCarUtilzation(RequestNewOrder: Models.RequestNewOrder<TyreStateModels.TyreStatePreviewModel[]>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
                                
    return this.httpClient.post<DepositeModels.DepositePreviewListModel>(`${this.environmentService.getApiURL()}/tyre-state/set-utilize-car-tyre-states`, RequestNewOrder, options);
  }

  public getCarCurrentTyreStates(Car: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Car.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreStateModels.TyreStatePreviewModel[]>>(`${this.environmentService.getApiURL()}/tyre-state/current-car-tyre-states`, Car, options);
  }
}
